import React, { useState } from 'react';
import './App.css';
import InvestmentOne from './Components/InvestmentOne';
import InvestmentTwo from './Components/InvestmentTwo';
import Core from './Components/Core';
import Chart from './Components/Chart';

function App() {
  // State
  const [inputs, setInputs] = useState({
    investment1: null,
    investment2: null,
    initialInvestment: null,
    annualAddition: null,
    investmentReturn: null,
    duration: null,
  });

  // Update State
  const updateInputs = (e) => {
    const values = e.target.name;
    if (!isNaN(e.target.value)) {
      setInputs({
        ...inputs,
        [values]: e.target.value,
      });
    }
  };

  // Future Value Function
  function FV(rate, nper, pmt, pv, type) {
    var pow = Math.pow(1 + rate, nper),
      fv;
    if (rate) {
      fv = (pmt * (1 + rate * type) * (1 - pow)) / rate - pv * pow;
    } else {
      fv = -1 * (pv + pmt * nper);
    }
    return fv.toFixed(2);
  }

  // Format numbers into currency Function
  function formatMoney(
    amount,
    decimalCount = 2,
    decimal = '.',
    thousands = ',',
    currencySymbol = '$'
  ) {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? '-' : '';

      let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
      let j = i.length > 3 ? i.length % 3 : 0;

      return (
        negativeSign +
        currencySymbol +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : '')
      );
    } catch (e) {
      console.log(e);
    }
  }

  // Scenarios
  const scenario1 = Math.abs(
    FV(
      inputs.investmentReturn / 100,
      inputs.duration,
      inputs.annualAddition,
      inputs.initialInvestment,
      0
    ) -
      FV(
        inputs.investmentReturn / 100 - inputs.investment1 / 100,
        inputs.duration,
        inputs.annualAddition,
        inputs.initialInvestment,
        0
      )
  );
  const scenario2 = Math.abs(
    FV(
      inputs.investmentReturn / 100,
      inputs.duration,
      inputs.annualAddition,
      inputs.initialInvestment,
      0
    ) -
      FV(
        inputs.investmentReturn / 100 - inputs.investment2 / 100,
        inputs.duration,
        inputs.annualAddition,
        inputs.initialInvestment,
        0
      )
  );

  const renderChart = () => {
    if (
      inputs.investment1 &&
      inputs.investment2 &&
      inputs.initialInvestment &&
      inputs.investmentReturn &&
      inputs.duration
    ) {
      return <Chart scenario1={scenario1} scenario2={scenario2} formatMoney={formatMoney} />;
    } else {
      return null;
    }
  };

  return (
    <div className="App">
      <div className="Grid">
        <div className="Panel1">
          <h1>Investment One</h1>
          <InvestmentOne updateInputs={updateInputs} />
          <p
            style={{
              visibility:
                inputs.investment1 &&
                inputs.investment2 &&
                inputs.initialInvestment &&
                inputs.investmentReturn &&
                inputs.duration
                  ? 'visible'
                  : 'hidden',
            }}
          >
            Cost: {formatMoney(scenario1)}
          </p>
        </div>

        <div className="Panel2">
          <Core updateInputs={updateInputs} />
        </div>

        <div className="Panel3">
          <h1>Investment Two</h1>
          <InvestmentTwo updateInputs={updateInputs} />
          <p
            style={{
              visibility:
                inputs.investment1 &&
                inputs.investment2 &&
                inputs.initialInvestment &&
                inputs.investmentReturn &&
                inputs.duration
                  ? 'visible'
                  : 'hidden',
            }}
          >
            Cost: {formatMoney(scenario2)}
          </p>
        </div>
      </div>
      {renderChart()}
    </div>
  );
}

export default App;
